const INITIAL_STATE = {
    paises: [],
    estados: [],
    cidades: [],
    bairros: []
}
    
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case 'PAISES_FETCH':
        return { ...state, paises: action.payload }
    case 'ESTADOS_FETCH':
        return { ...state, estados: action.payload }
    case 'CIDADES_FETCH':
        return { ...state, cidades: action.payload }
    case 'BAIRROS_FETCH':
        return { ...state, bairros: action.payload }
    default:
        return state
    }
}